/* eslint-disable no-underscore-dangle */
import {
  ElementNode,
  $createParagraphNode,
  RangeSelection,
  SerializedElementNode,
  Spread,
  LexicalEditor,
  EditorConfig,
  DOMConversionMap,
  ParagraphNode,
} from 'lexical';

import { $convertReferenceElement, $createReferenceNode } from './helpers';

export type SerializedReferenceNode = Spread<
  { version: 1; textFormat: number; textStyle: string },
  SerializedElementNode
>;

export class ReferenceNode extends ElementNode {
  createDOM(_config: EditorConfig, editor: LexicalEditor): HTMLElement {
    const div = document.createElement('div');
    div.classList.add('editor-reference');
    div.setAttribute('contenteditable', String(editor._editable));

    // Добавляем placeholder, если нода пуста
    this.updatePlaceholder(div);

    return div;
  }

  updatePlaceholder(dom: HTMLElement): void {
    const placeholder = dom.querySelector('.editor-reference-placeholder');
    if (this.isEmpty()) {
      if (!placeholder) {
        const placeholderDiv = document.createElement('div');
        placeholderDiv.classList.add('editor-reference-placeholder');
        placeholderDiv.textContent = 'Добавьте текст справки';
        dom.appendChild(placeholderDiv);
      }
    } else if (placeholder) {
      dom.removeChild(placeholder);
    }
  }

  static clone(node: ReferenceNode): ReferenceNode {
    return new ReferenceNode(node.__key);
  }

  static getType(): string {
    return 'reference-node';
  }

  static importDOM(): DOMConversionMap | null {
    return {
      div: () => ({
        conversion: $convertReferenceElement,
        priority: 0,
      }),
    };
  }

  updateDOM(_prevNode: unknown, dom: HTMLElement): boolean {
    // Обновляем placeholder при изменении содержимого
    this.updatePlaceholder(dom);

    return false; // Возвращаем false, чтобы Lexical не заменял DOM
  }

  insertNewAfter(
    rangeSelection: RangeSelection,
    restoreSelection: boolean,
  ): ParagraphNode {
    const newElement = $createParagraphNode();
    newElement.setTextFormat(rangeSelection.format);
    newElement.setTextStyle(rangeSelection.style);
    const direction = this.getDirection();
    newElement.setDirection(direction);
    newElement.setFormat(this.getFormatType());
    newElement.setStyle(this.getStyle());
    this.insertAfter(newElement, restoreSelection);

    return newElement;
  }

  static importJSON(serializedNode: SerializedReferenceNode): ReferenceNode {
    return $createReferenceNode().updateFromJSON(serializedNode);
  }

  exportJSON(): SerializedReferenceNode {
    return {
      ...super.exportJSON(),
      type: this.getType(),
      version: 1,
      textFormat: this.getTextFormat(),
      textStyle: this.getTextStyle(),
    };
  }
}
